import { render } from "./Catalog_EditDialog.vue?vue&type=template&id=bb85ac34&ts=true"
import script from "./Catalog_EditDialog.vue?vue&type=script&lang=ts"
export * from "./Catalog_EditDialog.vue?vue&type=script&lang=ts"

import "./Catalog_EditDialog.vue?vue&type=style&index=0&id=bb85ac34&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__